import { ContractStepsNames, getContractSteps } from "../contractSteps";

import { Contract } from "@/components/Contracts/contract.interface";

export const getStepOrderByName = (
  currentContract: Contract,
  stepName: ContractStepsNames
): number => {
  return getContractSteps(currentContract).findIndex(
    item => item.name === stepName
  );
};
